<template>
  <div class="form-container narrow">
    <div class="form-header">
      <h2>Log In</h2>
    </div>
    <div v-if="signupSuccess" class="success-message">
      Account created successfully! Please log in.
    </div>
    <form @submit.prevent="handleSubmit" class="form">
      <div class="form-section">
        <div class="form-group">
          <label for="email" class="required">Email</label>
          <input
            type="email"
            id="email"
            v-model="formData.email"
            class="form-control"
            required
          />
        </div>

        <div class="form-group">
          <label for="password" class="required">Password</label>
          <input
            type="password"
            id="password"
            v-model="formData.password"
            class="form-control"
            required
          />
        </div>
        <div class="form-group">
          <router-link to="/forgotpassword" class="link forgot-password">Forgot Password?</router-link>
        </div>
      </div>

      <div class="error-message" v-if="error">{{ error }}</div>

      <div class="form-actions vertical">
        <button type="submit" class="submit-button big" :disabled="loading">
          {{ loading ? 'Logging in...' : 'Log In' }}
        </button>
        <router-link to="/signup" class="link">Don't have an account? Sign up</router-link>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { login } from '@/scripts/auth';

const router = useRouter();
const route = useRoute();
const error = ref('');
const loading = ref(false);
const signupSuccess = ref(false);

const formData = ref({
  email: '',
  password: ''
});

onMounted(() => {
  signupSuccess.value = route.query.signup === 'success';
});

const handleSubmit = async () => {
  error.value = '';
  loading.value = true;
  const success = await login(formData.value.email, formData.value.password);
  loading.value = false;
  if (success) {
    router.push('/');
  } else {
    error.value = 'Invalid email or password';
  }
};
</script>

<style scoped>
@import '../styles/shared-form.css';
</style>
